import { Contract, ContractTenant } from '../../../../../../common/validations'
import { TerminationDisallowedReason } from '../../../../../../common/types'
import {
  TerminateSuggestion,
  TerminateSuggestionAction,
} from '../../../hooks/useTerminateSuggestions'
import { isChildTenant } from './isChildTenant'

type IsSuggestionDisabledParams = {
  suggestion: TerminateSuggestion
  contract: Contract
  tenant: ContractTenant
  terminateTenantIds: number[]
  contractModification: boolean
}

export const isSuggestionDisabled = ({
  suggestion,
  contract,
  tenant,
  terminateTenantIds,
  contractModification,
}: IsSuggestionDisabledParams) => {
  const isCurrentTenant = tenant.id === contract.tenant.id
  const { terminationDisallowedReason } = contract
  const isInEffectSuggestion =
    suggestion.id === TerminateSuggestionAction.IN_EFFECT

  if (isInEffectSuggestion) {
    return false
  }

  if (
    terminationDisallowedReason ===
    TerminationDisallowedReason.NOT_CONTRACT_PARTY
  ) {
    return !isCurrentTenant
  }

  if (terminationDisallowedReason) {
    return true
  }

  if (isCurrentTenant) {
    return false
  }

  if (!contractModification) {
    return true
  }

  if (isChildTenant(tenant)) {
    return false
  }

  return !terminateTenantIds.includes(contract.tenant.id)
}
